import { Stack, Title } from '@mantine/core'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useErrorMessages } from '../../constants/content'
import useSessionStorage from '../../hooks/useSessionStorage'
import { HELP_DRAWER_CONTENT_TYPE, RichText } from '../../plugins/contentful/api'
import client from '../../plugins/contentful/client'
import ParseRichText from '../Contentful/ParseRichText'
import ErrorMessage from '../ErrorMessage'
import Loading from '../Loading'

interface HelpDrawerDataProps {
  id: string
}

const HelpDrawerData: React.FC<HelpDrawerDataProps> = ({ id }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation()
  const errorMessages = useErrorMessages()
  const [title, setTitle] = useSessionStorage<string>(`helpDrawerTitle-${language}-${id}`)
  const [body, setBody] = useSessionStorage<RichText>(`helpDrawerBody-${language}-${id}`)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [error, setError] = useState<string>('')
  useEffect(() => {
    if (!body && !title) {
      setIsLoading(true)
      client
        .getEntries({
          content_type: HELP_DRAWER_CONTENT_TYPE,
          'fields.id[all]': id,
          locale: language,
        })
        .then(response => {
          setTitle(response.items[0].fields.title as string)
          setBody(response.items[0].fields.body as RichText)
        })
        .catch(err => {
          console.warn(err)
          setError(err.message)
        })
        .finally(() => {
          setIsLoading(false)
        })
    }
  }, [body, title, id, setTitle, setBody, t, language])

  return (
    <Stack style={{ gap: 'md' }}>
      {isLoading && <Loading />}
      {error && <ErrorMessage message={errorMessages.cmsConnection} details={error} />}
      {!isLoading && !error && (
        <>
          <Title order={3}>{title}</Title>
          {body && <ParseRichText jsonData={body} />}
        </>
      )}
    </Stack>
  )
}

export default HelpDrawerData
